import { apiSlice } from './apiSlice';

export interface ResourceShare {
  _id: string;
  resourceArn: string;
  principalId: string;
  principalType: 'user' | 'group' | 'email';
  role: 'owner' | 'writer' | 'reader' | 'commenter';
  grantedBy: string;
  grantedAt: string;
  expiresAt: string | null;
  active: boolean;
}

export interface ResourceSharesResult {
  count: number;
  shares: ResourceShare[];
}
export interface ResourceShareResult {
  share: ResourceShare;
}

export const resourceSharesApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getResourceShares: builder.query<
      ResourceSharesResult,
      { resourceArn: string; limit?: number; offset?: number }
    >({
      query: ({ resourceArn, ...params }) => ({
        url: `/shares/resource/${encodeURIComponent(resourceArn)}`,
        params,
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.shares.map(({ _id }) => ({ type: 'ResourceShare' as const, id: _id })),
              { type: 'ResourceShare', id: 'LOOKUP' },
            ]
          : [{ type: 'ResourceShare', id: 'LOOKUP' }],
    }),
    getPrincipalShares: builder.query<
      ResourceSharesResult,
      { principalId: string; limit?: number; offset?: number }
    >({
      query: ({ principalId, ...params }) => ({
        url: `/shares/principal/${encodeURIComponent(principalId)}`,
        params,
      }),
      providesTags: [{ type: 'ResourceShare', id: 'LOOKUP' }],
    }),
    getResourceShare: builder.query<ResourceShareResult, string>({
      query: (id) => `/shares/${id}`,
      providesTags: (_result, _error, id) => [{ type: 'ResourceShare', id }],
    }),
  }),
});

export const {
  useGetResourceSharesQuery,
  useLazyGetResourceSharesQuery,
  useGetPrincipalSharesQuery,
  useLazyGetPrincipalSharesQuery,
  useGetResourceShareQuery,
  useLazyGetResourceShareQuery,
} = resourceSharesApi;
